<template>
  <v-layout row wrap class="colored-background">
    <v-flex xs12 sm12 md12 class="mt-5 text-xs-center">
      <img width="52%" :src="assetRoot + 'musicplus.png'" />
    </v-flex>

    <v-flex v-if="mailVerified" xs12 sm12 md12 class="mt-5">
      <center>
        <v-img width="48" :src="assetRoot + 'check.png'" />
      </center>
    </v-flex>
    <v-flex v-else-if="isVerifyingMail" xs12 sm12 md12 class="mt-5">
      <center>
        <v-progress-circular width="4" size="50" indeterminate color="grey lighten-2" />
      </center>
    </v-flex>
    <v-flex v-else-if="verifyMailStatus === 'error'" xs12 sm12 md12 class="mt-5">
      <center>
        <v-icon size="70" color="red">clear</v-icon>
      </center>
    </v-flex>

    <v-flex xs12 sm12 md12 class="mt-4 text-xs-center">
      <span class="account-verification-for">Account creation for:<br />
      <span :class="mailVerified ? 'email-done' : 'email-error'">{{ $route.params.email }}</span></span>
    </v-flex>
    <v-flex v-if="mailVerified" xs12 sm12 md12 class="mt-5 text-xs-center">
      <span class="thank-you">Your account<br /> was successfully<br /> finalized!</span>
    </v-flex>
    <v-flex v-if="mailVerified" xs12 sm12 md12 class="mx-4 mt-5 text-xs-center">
      <span class="finalize-account">You can now <span class="action">download</span> and<br /> <span class="action">sign into the apps</span> to enjoy<br /> your free trial.</span>
    </v-flex>
    <v-flex v-if="mailVerified" xs12 sm12 md12 class="mt-5">
      <store-apps store_mode="store" />
    </v-flex>

    <v-flex v-if="verifyMailStatus === 'error'" xs12 sm12 md12 class="mx-5 mt-5 text-xs-center">
      <span class="error-message">{{ verifyMailErrorMessage }}</span>
    </v-flex>
    <v-flex xs12 sm12 md12 class="mb-5">

    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters } from 'vuex'

  import StoreApps from '../flow/StoreApps'

  export default {
    components: {
      'store-apps': StoreApps
    },
    data () {
      return {
        timeout: null
      }
    },
    methods: {
      verify () {
        let payload = {
          env: this.env,
          body: {
            app_key: this.appKey,
            device_type: this.deviceType,
            installation_id: this.sessionId,
            confirmation_code: this.$route.params.token
          }
        }
        this.$store.dispatch('VERIFY_MAIL', payload)
          .then((response) => {
            this.$session.set(this.userInstanceIdStorageKey, response.user_instance_id);
            this.$session.set(this.accessTokenStorageKey, response.access_token);
            this.$session.set(this.accessTokenExpirationTimeStorageKey, response.access_token_expiration_time);
            this.$session.set(this.refreshTokenStorageKey, response.refresh_token);


          })
          .catch((error) => console.log(error))
      }
    },
    computed: {
      ...mapGetters([
        'env',
        'assetRoot',
        'appKey',
        'deviceType',
        'sessionId',

        'verifyMailStatus',
        'verifyMailErrorMessage',

        'userInstanceIdStorageKey',
        'accessTokenStorageKey',
        'accessTokenExpirationTimeStorageKey',
        'refreshTokenStorageKey',
      ]),
      cantVerifyEmail () {
        return this.$route.params.token === ''
      },
      isVerifyingMail () {
        return this.verifyMailStatus === 'progress'
      },
      mailVerified () {
        return this.verifyMailStatus === 'done'
      }
    },
    mounted () {
      this.$nextTick(function () {

      })
    },
    watch: {
      sessionId (newVal) {
        if (newVal === '') { return }
        this.verify()
      }
    }
  }
</script>

<style scoped>
.colored-background {
  background-size: contain;
  background-image:url('https://storage.googleapis.com/mwm-appstore-assets/website_mwm/global_offer/BG-opti.jpg');
  background-color: #05151F;
}

.thank-you {
  font-family: CenturyGothic;
  font-size: 35px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.account-verification-for {
  font-family: CenturyGothic;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.account-verification-for .email-error {
  font-weight: bold;
  color: red;
}

.account-verification-for .email-done {
  font-weight: bold;
  color: #7dff00;
}

.finalize-account {
  font-family: CenturyGothic;
  font-size: 17px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.finalize-account .action {
  color: #2c7fff;
}

.error-message {
  font-family: CenturyGothic;
  font-size: 1.8rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  text-transform: uppercase;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}
</style>
